import * as React from 'react';
type Props = {
  className?: string;
};
export function EggFree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Egg free"
      className={className}
    >
      <path
        d="M14.4065 26.7026L8.10326 34.2575M23.7858 19.3242C23.2921 15.4208 20.4543 13.3221 20.4543 13.3221M25.2721 13.679L31.8961 5.73889M23.3544 29.2421C27.2122 26.7149 27.7834 20.6751 26.4695 16.4263C25.1331 12.1052 21.1884 7.37932 16.8086 11.0272C13.2403 13.999 11.8264 21.0479 13.7702 25.4024C15.5511 29.392 19.5233 31.752 23.3544 29.2421ZM20.0004 38.5722C30.2571 38.5722 38.5714 30.2571 38.5714 19.9997C38.5714 14.5861 36.2549 9.71256 32.5577 6.31804C29.2523 3.28186 24.8428 1.42859 20.0004 1.42859C9.74369 1.42859 1.42859 9.74297 1.42859 19.9997C1.42859 30.2571 9.74369 38.5722 20.0004 38.5722Z"
        stroke="currentColor"
      />
    </svg>
  );
}
